import { CloudUploadOutlined } from '@mui/icons-material';
import { Button, Stack } from '@mui/material';
import React, { useEffect } from 'react';
import { DropZoneStylerProps } from './variables/DropZoneStylersProps';
import { Base64Selector } from 'utils/Base64Selector';
import PreviewChip from './components/PreviewChip';
import ErrorSupportForAllMui from '../ErrorSupportForAllMui/ErrorSupportForAllMui';
import { themeColors } from 'Global/JsxThemeColor/JsxThemeColor';
import FindLangKey from 'Global/Functions/FindLangKey/FindLangKey';

const FileUploaderDropZone = ({
  onChange = () => {},
  errors,
  name,
  label,
  isEnglish = false,
  stateLift = null,
  onFileContentChanges = null,
  initialImage = null,
  initialName = null,
  excludeHeader = false,
  resetState = false,
}) => {
  const [SelectBase64, setSelectBase64] = React.useState({
    fileName: !initialImage ? '' : initialName,
    fileContent: initialImage ?? '',
  });

  const [sizeError, setSizeError] = React.useState(null);

  const fileInputRef = React.useRef(null);
  const maxFileSize = 1 * 2048 * 2048; // 1MB in bytes

  React.useEffect(() => {
    if (
      SelectBase64.fileContent !== '' &&
      SelectBase64.fileName !== ''
    )
      onChange(SelectBase64);
  }, [SelectBase64]);

  React.useEffect(() => {
    if (stateLift !== null) {
      stateLift(SelectBase64);
    }
  }, [stateLift, SelectBase64]);

  React.useEffect(() => {
    if (onFileContentChanges) {
      setSelectBase64((prev) => ({
        ...prev,
        fileContent: onFileContentChanges,
      }));
      if (fileInputRef && fileInputRef.current) {
        fileInputRef.current.value = null;
      }
    }
  }, [onFileContentChanges]);

  useEffect(() => {
    if (resetState) {
      setSelectBase64({
        fileName: !initialImage ? '' : initialName,
        fileContent: initialImage ?? '',
      });
    }
  }, [resetState]);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file && file.size > maxFileSize) {
      setSizeError(`File size exceeds 2MB limit`);
      if (fileInputRef.current) {
        fileInputRef.current.value = null;
      }
    } else {
      setSizeError(null);
      Base64Selector(event, setSelectBase64, excludeHeader);
    }
  };

  const dropzone_label = FindLangKey(
    'general-public-uploader-label-upload-file'
  );

  return (
    <React.Fragment>
      <Stack>
        <Button
          startIcon={
            <CloudUploadOutlined
              sx={{
                transform: 'scale(2)',
                color: `${themeColors.ColorPrimary} !important`,
                marginLeft: '.5em',
              }}
            />
          }
          fullWidth
          color="colorPrimer"
          variant="outlined"
          sx={{ ...DropZoneStylerProps }}
          onClick={() => fileInputRef.current.click()}
        >
          <input
            onChange={handleFileChange}
            type="file"
            accept=".jpg, .png, .jpeg, .gif, .bmp, .tif, .tiff, application/pdf, image/*"
            hidden
            ref={fileInputRef}
          />
          <Stack
            alignItems="center"
            justifyContent="center"
          >
            {label ? (
              <p
                style={{
                  color: `${themeColors.ColorPrimary} !important`,
                }}
              >
                {label}
              </p>
            ) : (
              <p
                style={{
                  color: `${themeColors.ColorPrimary} !important`,
                }}
              >
                {dropzone_label}
              </p>
            )}
          </Stack>
          {errors && !!errors[name] ? (
            <ErrorSupportForAllMui label={label} />
          ) : (
            <></>
          )}
          {SelectBase64.fileName !== '' ? (
            <PreviewChip
              SelectBase64={SelectBase64}
              setSelectBase64={setSelectBase64}
              isEnglish={isEnglish}
              fileInputRef={fileInputRef}
              onChange={onChange}
            />
          ) : (
            <></>
          )}
        </Button>
        {sizeError && (
          <p style={{ color: 'red', marginTop: '8px' }}>
            {sizeError}
          </p>
        )}
      </Stack>
    </React.Fragment>
  );
};

export default FileUploaderDropZone;
